<div class="p-6 sm:p-8 grid grid-cols-1 xl:grid-cols-2 gap-8">
    <form [formGroup]="selectedStoryTypeForm" class="contents">

        <mat-card>
            <mat-card-header>
                <mat-card-title>Client Information</mat-card-title>
                <mat-card-subtitle>Details about the destination client.</mat-card-subtitle>
            </mat-card-header>
            <mat-card-content>
                <div class="grid grid-cols-1 md:grid-cols-2 gap-x-6">
                    <mat-form-field class="w-full">
                        <mat-label>Client</mat-label>
                        <input (keyup)="onKeyupAutosave()" matInput formControlName="ds_client">
                    </mat-form-field>

                    <mat-form-field class="w-full">
                        <mat-label>Client Name</mat-label>
                        <input (keyup)="onKeyupAutosave()" matInput formControlName="ds_commonname">
                    </mat-form-field>

                    <mat-form-field class="w-full">
                        <mat-label>Client Legal Name</mat-label>
                        <input (keyup)="onKeyupAutosave()" matInput formControlName="ds_legalname">
                    </mat-form-field>

                    <mat-form-field class="w-full">
                        <mat-label>Client Email</mat-label>
                        <input (keyup)="onKeyupAutosave()" matInput formControlName="ds_email" type="email">
                    </mat-form-field>

                    <div class="w-full md:col-span-2">
                        <mat-label class="text-gray-600 dark:text-gray-400">Client Phone</mat-label>
                        <app-phone-input class="mt-2" [ngModelOptions]="{standalone: true}"
                                         [(ngModel)]="selectedStoryTypeForm.value.ds_phone"
                                         (ngModelChange)="onKeyupAutosave()">
                        </app-phone-input>
                    </div>

                    <mat-form-field class="w-full md:col-span-2">
                        <mat-label>Client Website</mat-label>
                        <input (keyup)="onKeyupAutosave()" matInput formControlName="ds_website">
                    </mat-form-field>

                    <mat-form-field class="w-full md:col-span-2">
                        <mat-label>Client Address</mat-label>
                        <input (keyup)="onKeyupAutosave()" matInput formControlName="ds_address1">
                    </mat-form-field>

                    <mat-form-field class="w-full">
                        <mat-label>Client ID</mat-label>
                        <input matInput readonly formControlName="id_client">
                    </mat-form-field>
                </div>
            </mat-card-content>
        </mat-card>

        <mat-card>
            <mat-card-header>
                <mat-card-title>Manage Destination Managers</mat-card-title>
                <mat-card-subtitle>Add or remove managers associated with this client.</mat-card-subtitle>
            </mat-card-header>
            <mat-card-content>
                <div class="flex flex-col sm:flex-row items-start gap-4 mb-6">
                    <mat-form-field class="flex-auto">
                        <mat-label>Search for a manager to add</mat-label>
                        <input type="text"
                               placeholder="Start typing a name or email..."
                               aria-label="Find Manager"
                               (blur)="onBlur()"
                               (keyup)="onKeyupAutoSearch($event)"
                               matInput
                               [formControl]="parentControl"
                               [matAutocomplete]="auto">
                        <mat-autocomplete #auto="matAutocomplete"
                                          requireSelection="true"
                                          (optionSelected)="optionSelected($event)"
                                          [displayWith]="displayFn"
                                          autoActiveFirstOption="true">
                            <mat-option *ngFor="let user of filteredParents | async" [value]="user">
                                {{ user.ds_email + ' (' + user.ds_firstname + ')' }}
                            </mat-option>
                        </mat-autocomplete>
                        <mat-error *ngIf="parentCheckerRequired && parentControl.invalid && (parentControl.touched || parentControl.dirty)">
                            Please select a valid manager from the list.
                        </mat-error>
                    </mat-form-field>
                    <button mat-raised-button
                            color="primary"
                            class="shrink-0 sm:mt-2"
                            [disabled]="!parentControl.value || parentControl.invalid"
                            (click)="addToMapList()">
                        <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>
                        <span class="ml-2">Add</span>
                    </button>
                </div>

                <mat-divider class="mb-6"></mat-divider>

                <mat-form-field class="w-full">
                    <mat-label>Filter added managers</mat-label>
                    <mat-icon matPrefix [svgIcon]="'heroicons_outline:magnifying-glass'"></mat-icon>
                    <input matInput
                           placeholder="Search by email"
                           [formControl]="inputInternalSearchControl"
                           (keyup)="searchMapList()">
                </mat-form-field>

                <div class="border rounded-md overflow-hidden dark:border-gray-700">
                    <mat-list role="list">
                        <ng-container *ngIf="filteredMapList.length > 0; else noManagers">
                            <ng-container *ngFor="let mapElement of filteredMapList; let last = last">
                                <mat-list-item role="listitem">
                                    <mat-icon matListItemAvatar [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
                                    <div matListItemTitle>{{ mapElement.ds_firstname }} {{ mapElement.ds_lastname }}</div>
                                    <div matListItemLine>{{ mapElement.ds_email }}</div>
                                    <button mat-icon-button
                                            matListItemMeta
                                            matTooltip="Remove Manager"
                                            (click)="deleteTag(mapElement.id_user, 'id_user')">
                                        <mat-icon [svgIcon]="'heroicons_outline:trash'"></mat-icon>
                                    </button>
                                </mat-list-item>
                                <mat-divider *ngIf="!last"></mat-divider>
                            </ng-container>
                        </ng-container>
                    </mat-list>
                </div>

                <ng-template #noManagers>
                    <div class="flex flex-col items-center justify-center p-8 text-gray-500 text-center">
                        <mat-icon class="icon-size-12" [svgIcon]="'heroicons_outline:users'"></mat-icon>
                        <p class="mt-4 font-medium">No managers assigned</p>
                        <p class="text-sm">Use the search bar above to find and add managers.</p>
                    </div>
                </ng-template>
            </mat-card-content>
        </mat-card>
    </form>
</div>
